import React, { useState } from "react";
import "../../assets/css/RequestDiscountCode/RequestDiscountCode.css";
import "../../assets/css/HeaderLogo/headerLogo.css";
import { Button, CircularProgress, TextField, Typography } from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";

const DiscountCodeComponent: React.FC = () => {
  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [societa, setSocieta] = useState("");
  const [ruolo, setRuolo] = useState("");
  const [email, setEmail] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isEmailValid = isValidEmail(email);
  const isFormValid =
    nome.trim() !== "" &&
    cognome.trim() !== "" &&
    societa.trim() !== "" &&
    ruolo.trim() !== "" &&
    isEmailValid &&
    privacyPolicy;

  const handleSendEmail = () => {
    setIsLoading(true);

    setTimeout(() => {
      const subject = encodeURIComponent(
        "RICHIESTA CODICE SCONTO – JUNIOR JEDI"
      );
      const body = encodeURIComponent(
        `Si richiede codice sconto per il seguente utente:\n
Nome: ${nome}
Cognome: ${cognome}
Società: ${societa}
Ruolo: ${ruolo}
Email: ${email}`
      );

      window.location.href = `mailto:info@legalfarm.it?subject=${subject}&body=${body}`;

      setTimeout(() => {
        window.location.href =
          "https://www.legalfarm.it/cessione-quote-srl-online";
      }, 3000);

      setIsLoading(false);
    }, 3000);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: 16,
        maxWidth: "600px",
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        style={{ fontFamily: "Poppins, sans-serif", color: "#001f3f" }}
      >
        Legalfarm X Junior Jedi
      </Typography>

      <Typography
        style={{
          fontSize: "14px",
          color: "#001f3f",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        Compila i campi sottostanti e invia una richiesta per ricevere un{" "}
        <span style={{ fontWeight: "bold" }}>codice sconto di €40</span> per
        l'acquisto del servizio di cessione quote online.
      </Typography>

      <div className="container-textfield-signup" style={{ display: "flex" }}>
        <TextField
          variant="standard"
          label={`Nome`}
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          InputProps={{ className: "input-textfield-signup" }}
          fullWidth
        />

        <TextField
          label={`Cognome`}
          variant="standard"
          value={cognome}
          onChange={(e) => setCognome(e.target.value)}
          InputProps={{ className: "input-textfield-signup" }}
          fullWidth
        />
      </div>

      <div
        className="container-textfield-signup"
        style={{
          display: "flex",
        }}
      >
        <TextField
          label={`Ruolo`}
          variant="standard"
          value={ruolo}
          onChange={(e) => setRuolo(e.target.value)}
          InputProps={{ className: "input-textfield-signup" }}
          fullWidth
        />
        <TextField
          label={`Società`}
          variant="standard"
          value={societa}
          onChange={(e) => setSocieta(e.target.value)}
          InputProps={{ className: "input-textfield-signup" }}
          fullWidth
        />
      </div>

      <TextField
        label={`Email`}
        value={email}
        variant="standard"
        onChange={(e) => setEmail(e.target.value)}
        InputProps={{ className: "input-textfield" }}
        fullWidth
        error={email !== "" && !isEmailValid}
        helperText={
          email !== "" && !isEmailValid
            ? `Inserisci un indirizzo email valido`
            : " "
        }
      />

      <div style={{ marginTop: "10px" }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={privacyPolicy}
              onChange={(e) => setPrivacyPolicy(e.target.checked)}
              name="privacyPolicy"
              color="primary"
              sx={{
                color: "#001f3f",
                "&.Mui-checked": { color: "#001f3f" },
              }}
            />
          }
          label={
            <Typography
              sx={{
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px",
                color: "#001f3f",
              }}
            >
              Prendo atto che i dati inseriti nei campi saranno utilizzati
              esclusivamente per l'invio di un codice sconto. Il conferimento
              dei dati è facoltativo, ma necessario per ricevere il codice. I
              dati non saranno conservati, profilati, né comunicati a terzi e
              verranno eliminati immediatamente dopo l’invio del codice sconto.
            </Typography>
          }
        />
      </div>
      <Button
        color="primary"
        variant="contained"
        onClick={handleSendEmail}
        disabled={!isFormValid || isLoading}
        style={{
          borderRadius: "5px",
          textTransform: "initial",
          marginTop: "30px",
          alignSelf: "center",
          width: "230px",
          height: "40px",
          boxShadow: "none",
          fontFamily: "Poppins, sans-serif",
          backgroundColor:
            !isFormValid || isLoading ? "rgba(0, 0, 0, 0.12)" : "#f7b801",
          color: !isFormValid || isLoading ? "rgba(0, 0, 0, 0.12)" : "#001f3f",
        }}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Richiedi codice sconto"
        )}
      </Button>
    </div>
  );
};

export default DiscountCodeComponent;
